import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { CONTROL_INPUT, MUTED_LABEL } from './daily-entry-ui.js';

interface Terminal {
  id: string | number;
  name?: string;
  terminal_name?: string;
  label?: string;
  fedex_code?: string;
}

interface DailyEntryContextRailProps {
  terminals: Terminal[];
  selectedTerminalId: string;
  selectedDate: string;
  onTerminalChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

export default function DailyEntryContextRail({ terminals, selectedTerminalId, selectedDate, onTerminalChange, onDateChange }: DailyEntryContextRailProps) {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.gold, marginBottom: 12 }}>
        Daily Entry context rail
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
        <div>
          <label style={MUTED_LABEL}>Terminal scope</label>
          <select value={selectedTerminalId} onChange={(event) => onTerminalChange(event.target.value)} style={CONTROL_INPUT}>
            <option value="">All terminals</option>
            {terminals.map((terminal: Terminal) => (
              <option key={terminal.id} value={terminal.id}>{terminal.name || terminal.terminal_name || terminal.label || terminal.fedex_code || terminal.id}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={MUTED_LABEL}>Entry date</label>
          <input type="date" value={selectedDate} onChange={(event) => onDateChange(event.target.value)} style={CONTROL_INPUT} />
        </div>
      </div>
    </div>
  );
}
